import request from '@/utils/request'

export function getSearchResult(params) {
  return request({
    url: `/bus/all/list`,
    methods: 'GET',
    params
  })
}
